import { render, staticRenderFns } from "./HonorariosTab.vue?vue&type=template&id=b9fce03a"
import script from "./HonorariosTab.vue?vue&type=script&lang=js"
export * from "./HonorariosTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports